module.exports = __webpack_public_path__ + "img/domain.0c8698b6.svg";